













































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import HoseiImageSidebar from "../../components/HoseiImageSidebar.vue";
import { BModal } from 'bootstrap-vue';
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { SheetActivity, Examinee, SheetActivityHoseiPosition, SheetField } from "../../modules/teacher/SheetUpload"
import jsZip from "jszip";


export interface Data {
  sheet_id: string
  sheet: any
  sheetFields: SheetField[]
  examinees: Examinee[]
  currentExaminee: Examinee | null
  currentSheetActivity: SheetActivity
  currentExamineeIdx: number
  currentSheetActivityIdx: number
  errors: string[]
  meiboErrors: string[]
  scale: number
  rotates: number[]
  files: File[]
  ApiTypeEnum: Readonly<{None: number; Classroom: number; Teams: number}>
  circleSize: number
  is_hosei_enable: boolean
  windowHeight: number
  isHoseiImageSidebarVisible: boolean
  hoseiExaminee: Examinee
  is_exists_backup_image: boolean
  is_studnet_key_recog_enable: boolean
  recogSidebarVisible: boolean
  recogResults: any[]
  recogResultFields: any[]
  recogErrors: any[]
  isAbsentCheckSkip: boolean
  draggedImageCount: number
  previewImageRetryCount: number
  previewImageRetryTimer: number | null
  isPreviewImageFallbackLoading: boolean
  isPreviewImageFallbackExecuted: boolean
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
    "hosei-image-sidebar": HoseiImageSidebar,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalSheetUploadRef = ref<InstanceType<typeof BModal>>();
    const modalMeiboUploadRef = ref<InstanceType<typeof BModal>>();

    const SheetTypeEnum = Common.SheetTypeEnum;


    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      sheet_id: "",
      sheet: {score_positions_completed: true},
      sheetFields: [],
      examinees: [],
      currentExaminee: null,
      currentSheetActivity: null,
      currentExamineeIdx: 0,
      currentSheetActivityIdx: 0,
      errors: [],
      meiboErrors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      files: [],
      ApiTypeEnum: Common.ApiTypeEnum,
      circleSize: 40,
      is_hosei_enable: false,
      windowHeight: 0,
      isHoseiImageSidebarVisible: false,
      hoseiExaminee: null,
      is_exists_backup_image: false,
      is_studnet_key_recog_enable: false,
      recogSidebarVisible: false,
      recogResults: [],
      recogResultFields: [
        {key: "cut_image", label: "画像", sortable: true, class: 'text-center b-table-th-td'},
        {key: "recog_text", label: "認識結果", sortable: true, class: 'text-center b-table-th-td'},
      ],
      recogErrors: [],
      isAbsentCheckSkip: false,
      draggedImageCount: 0,
      previewImageRetryCount: 0,
      previewImageRetryTimer: null,
      isPreviewImageFallbackLoading: false,
      isPreviewImageFallbackExecuted: false,
    });


    /******************************
     * 答案アップロード済みの受験者リスト
     ******************************/

    const uploadedExaminees = computed((): Examinee[] => {
      return state.examinees.filter((x: Examinee) => x.sheetActivities.length > 0);
    });

    /******************************
     * 答案アップロード未の受験者リスト
     ******************************/

    const unUploadedExaminees = computed((): Examinee[] => {
      return state.examinees.filter((x: Examinee) => x.sheetActivities.length == 0);
    });

    /******************************
     * 答案アップロード未の受験者リスト
     ******************************/

    const currentSheetFields = computed((): SheetField[] => {
      if(state.currentSheetActivity){
        return state.sheetFields.filter(x => x.page == state.currentSheetActivity.page);
      }else{
        return [];
      }
    });

    /******************************
     * プレビュー画像のリトライ状態を初期化する
     ******************************/
    
    const resetPreviewImageLoadState = () => {
      state.previewImageRetryCount = 0;
      state.isPreviewImageFallbackLoading = false;
      state.isPreviewImageFallbackExecuted = false;
      if(state.previewImageRetryTimer != null){
        clearTimeout(state.previewImageRetryTimer);
        state.previewImageRetryTimer = null;
      }
    }

    /******************************
     * 署名付きURL（imageUrl）と実表示用URL（imageSrc）を同時に更新する
     ******************************/

    const setSheetActivityImageSource = (sheetActivity: SheetActivity, imageUrl: string) => {
      sheetActivity.imageUrl = imageUrl;
      sheetActivity.imageSrc = imageUrl;
    }

    /******************************
     * 画像の実サイズを描画用プロパティに反映する
     ******************************/

    const setSheetActivityImageSize = (sheetActivity: SheetActivity, width: number, height: number) => {
      sheetActivity.baseWidth = width;
      sheetActivity.baseWidthCache = width;
      sheetActivity.baseHeight = height;
      sheetActivity.baseHeightCache = height;
    }

    /******************************
     * 画像ソースの形式に応じてサイズ取得方法を切り替える
     ******************************/

    const loadImageSizeBySource = async (imageSrc: string): Promise<{ width: number; height: number }> => {
      if(imageSrc.startsWith("data:image/")){
        return await Common.getImageSizeFromBase64DataUrl(imageSrc);
      }
      return await Common.getImageSizeFromPresignedURL(imageSrc);
    }

    /******************************
     * 署名付きURLによる画像取得リトライ2回でも失敗した場合
     * 最終手段としてサーバー経由でBase64画像を取得し、表示ソースを差し替える
     ******************************/

    const setSheetActivityImageByBase64 = async (sheetActivity: SheetActivity) => {
      const response = await http.get(`/api/teacher/sheet_upload/download_base64_image/${state.sheet_id}/${sheetActivity.id}`);
      const imageSrc = `data:image/jpeg;base64,${response.data.base64_image}`;
      sheetActivity.imageSrc = imageSrc;
      const size = await loadImageSizeBySource(imageSrc);
      setSheetActivityImageSize(sheetActivity, size.width, size.height);
    }

    /******************************
     * 短い遅延を入れて同一URLを再セットし、画像再取得を試みる
     ******************************/

    const setPreviewRetryImageSrc = () => {
      if(!state.currentSheetActivity || !state.currentSheetActivity.imageUrl){
        return;
      }
      state.previewImageRetryCount++;
      state.currentSheetActivity.imageSrc = null;
      if(state.previewImageRetryTimer != null){
        clearTimeout(state.previewImageRetryTimer);
      }
      state.previewImageRetryTimer = window.setTimeout(() => {
        state.currentSheetActivity.imageSrc = state.currentSheetActivity.imageUrl;
      }, 200);
    }

    /******************************
     * 画像読込エラー時: 2回までは再試行、それでも失敗した場合はBase64フォールバック
     ******************************/

    const previewImageError = async () => {
      if(!state.currentSheetActivity){
        return;
      }
      if(state.previewImageRetryCount < 2){
        setPreviewRetryImageSrc();
        return;
      }
      if(state.isPreviewImageFallbackLoading || state.isPreviewImageFallbackExecuted){
        return;
      }
      state.isPreviewImageFallbackLoading = true;
      try{
        await setSheetActivityImageByBase64(state.currentSheetActivity);
        state.isPreviewImageFallbackExecuted = true;
      }catch(error){
        console.error(error);
      }finally{
        state.isPreviewImageFallbackLoading = false;
      }
    }

    /******************************
     * imgタグのスタイル
     ******************************/

    const imageStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        style["width"] = `${sheetActivitiy.baseWidthCache * state.scale}px`;
        style["height"] = `${sheetActivitiy.baseHeightCache * state.scale}px`;
      }
      
      return style;
    });

    /******************************
     * imgの親divのスタイル
     ******************************/

    const imageWrapStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        if(sheetActivitiy.angle == 0 || sheetActivitiy.angle == 180){
          style["height"] = `${(sheetActivitiy.baseHeight * state.scale) + 30}px`;
        }else{
          style["height"] = `${(sheetActivitiy.baseWidth * state.scale) + 30}px`;
        }
      }
      return style;
    });

    /******************************
     * ドロップエリアの文言
     ******************************/

    const dropAreaText = computed((): string => {
      let text = "";

      if(state.sheet){
        if(context.root.$store.getters.isEntranceOrPractice){
          text = "答案用紙を「受験者一覧の表示順」に並び替えて「模範解答と同じ設定」にてスキャンし、こちらにアップロードしてください。<br>";
        }else if(state.sheet.api_type == state.ApiTypeEnum.Classroom){
          text = "答案用紙を「受験者一覧の表示順」に並び替えて「模範解答と同じ設定」にてスキャンし、こちらにアップロードしてください。<br>";
        }else{
          text = "答案用紙を「出席番号順」に並び替えて「模範解答と同じ設定」にてスキャンし、こちらにアップロードしてください。<br>";
        }
      }
      
      text += "<span style='color:red;'>※JpegファイルやPDFファイルをそのままアップロードすることも可能となりました。（PDFは変換プログラムが作動するため、登録に時間を要します）</span><br>";
      text += "<span style='color:red;'>※PDFファイルのアップロード可能なページ数は200ページ、ファイルサイズは30MBまでです。超過する場合は分割してアップロードしてください。</span>";
      return text;
    });

    /******************************
     * 選択答案情報切り替え
     ******************************/

    const changeCurrent = async (examinee: Examinee, sheetActivityIdx: number) => {
      if (examinee) {
        state.currentExaminee = null;
        const sheetActivity = examinee.sheetActivities[sheetActivityIdx];

        /******************************
         * 画像がキャッシュされていない場合はAPIで署名URLを取得
         ******************************/
        if (sheetActivity.imageUrl == null) {
          const param: object = {
            sheet_id: state.sheet_id,
            student_no: examinee.student_no
          };

          await http.get(`/api/teacher/sheet_upload/download_image?${Common.BuildQuery(param, "")}`).then(async response => {
            const imageUrls: string[] = response.data.image_urls;

            for (let i = 0; i < examinee.sheetActivities.length; i++) {
              setSheetActivityImageSource(examinee.sheetActivities[i], imageUrls[i]);
            }

            for (let i = 0; i < examinee.sheetActivities.length; i++) {
              try{
                /******************************
                 * 通常は署名付きURLからサイズ取得
                 ******************************/
                const size = await loadImageSizeBySource(examinee.sheetActivities[i].imageSrc);
                setSheetActivityImageSize(examinee.sheetActivities[i], size.width, size.height);
              }catch(error){
                try{
                  /******************************
                   * 署名付きURLで取得失敗した場合はBase64 APIへフォールバック
                   ******************************/
                  await setSheetActivityImageByBase64(examinee.sheetActivities[i]);
                }catch(fallbackError){
                  console.error(fallbackError);
                }
              }
            }
          }).catch(async error=>{
            if(error.response.status == 422){
              state.errors = error.response.data.errors;
            }else{
              state.errors = ["予期せぬ例外が発生しました。"];
            }
          });
        }

        state.currentExaminee = examinee;
        state.currentSheetActivity = sheetActivity;
        resetPreviewImageLoadState();
        if(state.currentSheetActivity.imageUrl && !state.currentSheetActivity.imageSrc){
          state.currentSheetActivity.imageSrc = state.currentSheetActivity.imageUrl;
        }
        state.currentExamineeIdx = state.examinees.indexOf(examinee);
        state.currentSheetActivityIdx = sheetActivityIdx;
        state.currentSheetActivity.angle = 0;
      } else {
        state.currentExaminee = null;
        state.currentSheetActivity = null;
        resetPreviewImageLoadState();
        state.currentExamineeIdx = 0;
        state.currentSheetActivityIdx = 0;
      }
    };


    /******************************
     * 拡大ボタン押下
     ******************************/

    const scaleUp = () => {
      state.scale += 0.02;
    };

    /******************************
     * 縮小ボタン押下
     ******************************/

    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.02;
      }
    };

    /******************************
     * 画像を表示エリアの横幅に合わせる
     ******************************/

    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        state.scale = imageAreaW / state.currentSheetActivity.baseWidth;
      }
    };

    /******************************
     * 画面サイズに合わせてレイアウト整形
     ******************************/

    const adjustHeight = () => {
      state.windowHeight = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = `${state.windowHeight - tableArea.offsetTop - 3}px`;
        imageArea.style.height = `${state.windowHeight - tableArea.offsetTop - 3}px`;
      }
    };

    /******************************
     * 左回転ボタン押下
     ******************************/

    const rotateLeft = async (): Promise<void> => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.currentSheetActivity.angle - 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    /******************************
     * 右回転ボタン押下
     ******************************/

    const rotateRight = async (): Promise<void> => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.currentSheetActivity.angle + 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    /******************************
     * 回転保存ボタン押下
     ******************************/

    const rotateSave = async (isConfirmMsg: boolean = true, isResutMsg: boolean = true) => {
      
      if(state.currentSheetActivity.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_activity_id: state.currentSheetActivity.id,
        angle: state.currentSheetActivity.angle,
        page: state.currentSheetActivityIdx + 1,
        student_no: state.currentExaminee.student_no,
        sheet_activity_hosei_positions: state.currentSheetActivity.sheetActivityHoseiPositions,
      };

      await http.post(`/api/teacher/sheet_upload/rotate/${state.sheet_id}`, param).then(async response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        setSheetActivityImageSource(state.currentSheetActivity, response.data.image_url);
        const size = await loadImageSizeBySource(state.currentSheetActivity.imageSrc);
        setSheetActivityImageSize(state.currentSheetActivity, size.width, size.height);
        resetPreviewImageLoadState();
        state.currentSheetActivity.angle = 0;
        state.currentSheetActivity.sheetActivityHoseiPositions = response.data.sheet_activity_hosei_positions.map((x: any) => new SheetActivityHoseiPosition(x, state.currentSheetActivity.baseWidth, state.currentSheetActivity.baseHeight));
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }

        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 一括回転
     ******************************/

    const rotateAll = async (angle: number) => {

      if(!window.confirm(`${state.currentSheetActivity.page}ページ目の一括回転を実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_id: state.sheet_id,
        sheet_activity_id: state.currentSheetActivity.id,
        angle: angle,
        page: state.currentSheetActivityIdx + 1,
      };

      await http.post(`/api/teacher/sheet_upload/rotate_all/${state.sheet_id}`, param).then(async response => {

        // キャッシュ済みの答案画像をクリア
        state.examinees.forEach((e: Examinee) => {
          e.sheetActivities.filter(x => x.page == state.currentSheetActivity.page).forEach((s: SheetActivity) => {
            s.imageUrl = null;
            s.imageSrc = null;
            s.baseWidth = 0;
            s.baseHeight = 0;
            s.sheetActivityHoseiPositions = response.data.sheet_activity_hosei_positions.filter((x: any) => x.sheet_activity_id == s.id).map((x: any) => new SheetActivityHoseiPosition(x, s.baseWidth, s.baseHeight));
          });
        });

        setSheetActivityImageSource(state.currentSheetActivity, response.data.image_url);
        const size = await loadImageSizeBySource(state.currentSheetActivity.imageSrc);
        setSheetActivityImageSize(state.currentSheetActivity, size.width, size.height);
        resetPreviewImageLoadState();
        state.currentSheetActivity.angle = 0;

        alert("処理が完了しました。");
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 名簿保存ボタン押下
     ******************************/

    const saveMeibo = async () => {

      if(!window.confirm("名簿を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.meiboErrors = [];

      const examinees: object[] = new Array<object>();
      state.examinees.forEach((e: Examinee) => {
        examinees.push({id: e.id, student_no_character: e.student_no_character, student_name: e.student_name, email: e.email});
      });

      await http.post(`/api/teacher/sheet_upload/update_meibo/${state.sheet_id}`, {examinees: examinees}).then(response => {
        alert("保存が完了しました。");

        modalMeiboUploadRef.value.hide();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.meiboErrors = error.response.data.errors;
        }else{
          state.meiboErrors = ["予期せぬ例外が発生しました。"];
        }
      });

      // modalMeiboUploadRef.value.hide();
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 欠席者モーダル表示
     ******************************/

    const showAbsentModal = async (file: FileList) => {
      state.files = [].slice.call(file).sort((a: any, b: any) => Common.strCmpLogicalW(a.name, b.name));
      const extension = Common.getFileExtension(state.files[0].name);

      // PDFの場合はファイルサイズ・ページ数チェック
      if(extension == "pdf"){
        
        if(state.files[0].size > 31457280){
          alert("ファイルサイズが30MBを超過しています。30MB以下にファイルを分割してアップロードしてください。");
          return;
        }
        
        const fileReader = new FileReader();
        fileReader.onload = async (event) => {
          const arrayBuffer = event.target.result as ArrayBuffer;
          const typedarray = new Uint8Array(arrayBuffer);
          // @ts-ignore
          await pdfjsLib.getDocument(typedarray).promise.then(async (pdfDoc: any) => {
            if(pdfDoc.numPages > 200){
              alert("PDFのページ数が200ページを超過しています。200ページ以下にファイルを分割してアップロードしてください。");
              return;
            }else{
              state.draggedImageCount = pdfDoc.numPages;
              modalSheetUploadRef.value.show();
            }            
          })
        }
        fileReader.readAsArrayBuffer(state.files[0]);
      }else if(extension == "zip"){
        let zip = new jsZip();
        const zipContent = await zip.loadAsync(state.files[0]);

        // zip内のjpgファイル数をカウント
        let count = 0;
        zipContent.forEach((_, file) => {
          if (!file.dir && /\.(jpe?g)$/i.test(file.name)) {
            count++;
          }
        });

        state.draggedImageCount = count;
        modalSheetUploadRef.value.show();
      }else if(extension == "jpg"){
        state.draggedImageCount = state.files.length;
        modalSheetUploadRef.value.show();
      }
    };

    /******************************
     * 名簿モーダル表示
     ******************************/

    const showMeiboModal = () => {
      state.meiboErrors = [];
      modalMeiboUploadRef.value.show();
    };

    /******************************
     * アップロードモーダル閉じる
     ******************************/

    const closeSheetUploadModal = () => {
      modalSheetUploadRef.value.hide();
      unUploadedExaminees.value.forEach((x: Examinee) => {
        x.isAbsent = false;
      });
    };

    /******************************
     * 並び順確認ボタン押下
     ******************************/

    const toSortAnswerImage = () => {
      context.root.$router.push(`/teacher_site/sort_answer_image/${state.sheet_id}`).catch(err => {});
    }

    /******************************
     * 答案アップロード
     ******************************/

    const upload = async () => {
      
      const extension = Common.getFileExtension(state.files[0].name);
      if(extension == "jpg"){
        await uploadJpg();
      }else if(extension == "zip"){
        await uploadZip();
      }else if(extension == "pdf"){
        await uploadPdf();
      }
      
      await initialize();
    }

    const getStudentNos = () => {
      if(state.isAbsentCheckSkip){
        // 「後で確認する」にチェックした場合、先頭から割り当てる
        // 例＞ 生徒数40名、答案38枚ドラッグ⇒出席番号1番から38番まで割り当て
        if(state.draggedImageCount >  unUploadedExaminees.value.length * state.sheet.page_count){
          // ドラッグした答案数(受験者数)が未アップロード生徒数を超過する場合は割り当て不可でエラー
          // 例＞ 未アップロード生徒数40名、50名分の答案をドラッグした場合エラー
          alert("ドラッグした画像数がアップロード可能な画像数（未アップロード受験者数 × ページ数）を超過しているためアップロードできません。");
          throw new Error("ドラッグした画像数がアップロード可能な画像数（未アップロード受験者数 × ページ数）を超過しているためアップロードできません。");
        }else{
          // アップロード可能生徒の先頭からファイル数分を対象にする
          return unUploadedExaminees.value.slice(0, state.draggedImageCount / state.sheet.page_count).map(x => x.student_no);
        }
      }else{
        // 欠席チェックボックス状態からアップロード対象を取得
        return unUploadedExaminees.value.filter((x: Examinee) => !x.isAbsent).map((x: Examinee) => x.student_no);
      }
    }

    /******************************
     * jpg答案アップロード
     ******************************/

    const uploadJpg = async () => {

      // 登録対象の出席番号リスト取得
      const studentNos = getStudentNos();

      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      if(studentNos.length * state.sheet.page_count != state.draggedImageCount){
        alert("アップロードに必要な画像数（アップロード対象受験者数 × ページ数）と選択した画像数が異なります。");
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      modalSheetUploadRef.value.hide();

      state.errors = [];
      context.root.$store.dispatch("showOverlay", {isShowProgress: true});

      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }

      let fileIdx = 0;
      let completedCount = 0;

      for(let i = 0; i < studentNos.length; i++){
        
        let fd = new FormData();

        for(let j = 0; j < state.sheet.page_count; j++){
          fd.append(`${j}`, state.files[fileIdx]);
          fileIdx++;
        }

        await http.post(`/api/teacher/sheet_upload/upload_jpg/${state.sheet_id}/${studentNos[i]}/${state.sheet.page_count}`, fd, config).then(() => {
          completedCount++;
          context.root.$store.commit("setProgressText", completedCount == studentNos.length ? "100.00" : Number.parseFloat(`${completedCount * 100 / studentNos.length}`).toFixed(2));
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。アップロードに失敗した生徒は再度アップロードを行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          return;
        }
      }

      await http.post(`/api/teacher/sheet_upload/upload_jpg_after_process/${state.sheet_id}`)
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0){
        context.root.$store.dispatch("hideOverlay");
        return;
      }

      await resolveAfterMilliSeconds();
      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * Zip答案アップロード
     ******************************/

    const uploadZip = async () => {

      // 登録対象の出席番号リスト取得
      const studentNos = getStudentNos();

      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      modalSheetUploadRef.value.hide();

      let fd = new FormData();
      fd.append("upload[file]", state.files[0]);
      fd.append("student_nos", JSON.stringify(studentNos));

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_upload/upload_zip/${state.sheet_id}`, fd).then(async response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * PDF答案アップロード
     ******************************/

    const uploadPdf = async () => {

      // 登録対象の出席番号リスト取得
      const studentNos = getStudentNos();

      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      modalSheetUploadRef.value.hide();

      let fd = new FormData();
      fd.append("upload[file]", state.files[0]);
      fd.append("student_nos", JSON.stringify(studentNos));

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_upload/upload_pdf/${state.sheet_id}`, fd).then(async response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * jpgアップロード完了後のインターバル
     ******************************/

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * 答案削除ボタン押下
     ******************************/

    const destroy = async (examinee: Examinee) => {
      if(!window.confirm(`出席番号${examinee.student_no}番の答案を削除します。よろしいですか？`)){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/sheet_upload/destroy/${state.sheet_id}/${examinee.student_no}`).then(response => {
        alert("処理が完了しました。");
        if(state.currentSheetActivity.student_id == examinee.student_no){
          changeCurrent(null, 0);
        }
        initialize();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 一括削除ボタン押下
     ******************************/

    const destroyAll = async () => {

      if(uploadedExaminees.value.length == 0){
        alert("削除対象が存在しません。");
        return;
      }

      if(!window.confirm("答案を一括削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/sheet_upload/destroy_all/${state.sheet_id}`).then(response => {
        changeCurrent(null, 0);
        initialize();
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 名簿アップロード
     ******************************/

    const uploadMeibo = async (file: any) => {

      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("名簿をアップロードします。よろしいですか？")){
        return;
      }

      state.meiboErrors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_upload/upload_meibo/${state.sheet_id}`, fd).then(response => {
        state.examinees.forEach(x => {
          const examinee = response.data.examinees.filter((examinee: any) => examinee.student_no == x.student_no);
          if(examinee.length > 0){
            x.student_no_character = examinee[0].student_no_character;
            x.student_name = examinee[0].student_name;
            x.email = examinee[0].email;
          }
        });

        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.meiboErrors = error.response.data.errors;
        }else{
          state.meiboErrors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 名簿テンプレートダウンロード
     ******************************/

    const downloadMeiboTemplate = () => {
      window.location.href = `/api/teacher/sheet_upload/download_meibo_template/${state.sheet_id}`;
    };

    /******************************
     * 切り出しボタン押下
     ******************************/

    const imageCut = async () => {

      if(!window.confirm("切り出しを実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/teacher/sheet_upload/create_cut_job/${state.sheet_id}`).then(response => {
        alert("答案切り出しを開始しました");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /******************************
     * keyUpイベント
     ******************************/

    const keyUp = (e: KeyboardEvent): void => {

      if (e.key == "ArrowDown") {
        e.preventDefault();

        const currentExamineeIdx = uploadedExaminees.value.indexOf(state.currentExaminee)
        if (currentExamineeIdx < (uploadedExaminees.value.length - 1)) {

          changeCurrent(uploadedExaminees.value[currentExamineeIdx + 1], state.currentSheetActivityIdx);
        }
        return;
      }

      if (e.key == "ArrowUp") {
        e.preventDefault();

        const currentExamineeIdx = uploadedExaminees.value.indexOf(state.currentExaminee)
        if (currentExamineeIdx > 0) {
          changeCurrent(uploadedExaminees.value[currentExamineeIdx - 1], state.currentSheetActivityIdx);
        }

        return;
      }

      if (e.key == "ArrowLeft") {
        e.preventDefault();

        if (state.currentSheetActivity.page > 1) {
          changeCurrent(state.currentExaminee, state.currentSheetActivityIdx - 1);
        }

        return;
      }
      
      if (e.key == "ArrowRight") {
        e.preventDefault();
        
        if (state.currentSheetActivity.page < state.sheet.page_count) {
          changeCurrent(state.currentExaminee, state.currentSheetActivityIdx + 1);
        }

        return;
      }
    }

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentW = computed(() => {
      return state.sheet.correct_image_size ? state.sheet.correct_image_size[0] * state.scale : 0;
    });

    const circleCenter = computed((): number => {
      return state.circleSize / 2;
    });

    const tdStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      style["width"] = `${circleCenter.value}px`;
      style["height"] = `${circleCenter.value}px`;
      return style;
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentH = computed(() => {
      return state.sheet.correct_image_size ? state.sheet.correct_image_size[1] * state.scale : 0;
    });

    const hoseiDragStop = (idx: number, rect: any) => {

      let posX = Math.round(rect.left + circleCenter.value) / state.scale;
      if(posX < 0){
        posX = state.currentSheetActivity.sheetActivityHoseiPositions[idx].rim[0] == 0 ? 1 : 0;
      }else if(posX > parentW.value / state.scale){
        posX = state.currentSheetActivity.sheetActivityHoseiPositions[idx].rim[0] == (parentW.value / state.scale) - 1 ? parentW.value / state.scale : (parentW.value / state.scale) - 1;
      }

      let posY = Math.round(rect.top + circleCenter.value) / state.scale;
      if(posY < 0){
        posY = state.currentSheetActivity.sheetActivityHoseiPositions[idx].rim[1] == 0 ? 1 : 0;
      }else if(posY > parentH.value / state.scale){
        posY = state.currentSheetActivity.sheetActivityHoseiPositions[idx].rim[1] == (parentH.value / state.scale) - 1 ? parentH.value / state.scale : (parentH.value / state.scale) - 1;
      }

      state.currentSheetActivity.sheetActivityHoseiPositions[idx].rim = [posX, posY]
    }

    /************************************************************
     * 出席番号認識
     ************************************************************/

    const recogStudentKey = async () => {

      // 既に認識実行済みの場合はAPIを実行せず結果を表示
      if(state.recogResults.length > 0){
        state.recogSidebarVisible = true;
        return;
      }

      if(!window.confirm(`出席番号の文字認識を実行します。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {
        examinee_ids: state.examinees.filter(x => !x.absent_flg).map(x => x.id)
      }

      await http.post(`/api/teacher/sheet_upload/recog_student_key/${state.sheet_id}`, param).then(response => {
        state.recogResults = response.data.results;
        state.recogSidebarVisible = true;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 並び替え実行
     ************************************************************/

    const sortByRecogResult = async () => {

      state.recogErrors = [];

      const studentNos = state.examinees.map(x => x.student_no);

      // 入力チェック
      state.recogResults.forEach((x: any, i: number) => {
        if(!x.recog_text || x.recog_text === ''){
          state.recogErrors.push(`${i + 1}行目の出席番号が入力されていません。`);
        }else if(!/^[0-9]+$/.test(x.recog_text)){
          state.recogErrors.push(`${i + 1}行目の出席番号に数字以外が入力されています。`);
        }else if(!studentNos.includes(Number(x.recog_text))){
          state.recogErrors.push(`${i + 1}行目の出席番号${x.recog_text}番は受験予定者の出席番号に存在しません。`);
        }
      });

      // 入力した出席番号に重複が無いかチェック
      const counts = state.recogResults.map(item => item.recog_text).reduce((acc: Record<string, number>, text) => {
        if (text != null) {
          acc[text] = (acc[text] || 0) + 1;
        }
        return acc;
      }, {});

      // 重複している文字列だけ抽出
      Object.keys(counts).filter(key => counts[key] > 1).forEach(x => {
        state.recogErrors.push(`出席番号${x}番が重複して入力されています。`);
      });

      // 入力エラーの場合は処理終了
      if(state.recogErrors.length > 0){
        return;
      }

      if(!window.confirm(`答案の並び替えを実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const sheetActivityItems: any[] = [];

      state.recogResults.forEach((recogResult: any) => {
        const examinee = state.examinees.find((x: Examinee) => x.id == recogResult.examinee_id);
        const sheetActivityItem = {
          ids: examinee.sheetActivities.map((x: SheetActivity) => x.id),
          student_id: Number(recogResult.recog_text),
          student_id_cache: examinee.student_no,
        }
        sheetActivityItems.push(sheetActivityItem);
      });

      const examinees: any[] = [];

      state.examinees.forEach(examinee => {
        const paramExaminee = {
          id: examinee.id,
          absent_flg: state.recogResults.filter((x: any) => Number(x.recog_text) == examinee.student_no).length == 0,
        }
        examinees.push(paramExaminee);
      });

      await http.post(`/api/teacher/sheet_upload/sort_by_recog_result/${state.sheet_id}`, {examinees: examinees, sheet_activity_items: sheetActivityItems}).then(async response => {
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.recogErrors = error.response.data.errors;
        }else{
          state.recogErrors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      if(state.recogErrors.length == 0){
        state.recogSidebarVisible = false;
        await initialize();
      }
    }

    /************************************************************
     * 補正処理
     ************************************************************/

    const perspectiveTransform = async () => {

      if(!window.confirm(`補正処理を実行します。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {
        sheet_activity_id: state.currentSheetActivity.id,
        sheet_activity_hosei_positions: state.currentSheetActivity.sheetActivityHoseiPositions
      }

      await http.post(`/api/teacher/sheet_upload/perspective_transform/${state.sheet_id}`, param).then(async response => {
        setSheetActivityImageSource(state.currentSheetActivity, response.data.image_url);
        const size = await loadImageSizeBySource(state.currentSheetActivity.imageSrc);
        setSheetActivityImageSize(state.currentSheetActivity, size.width, size.height);
        resetPreviewImageLoadState();
        state.currentSheetActivity.angle = 0;
        state.currentSheetActivity.sheetActivityHoseiPositions = response.data.sheet_activity_hosei_positions.map((x: any) => new SheetActivityHoseiPosition(x, state.currentSheetActivity.baseWidth, state.currentSheetActivity.baseHeight));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 補正リセット
     ************************************************************/

    const resetTransform = async () => {
      if(!window.confirm(`アップロード時点の画像に戻し、補正をリセットします。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {
        sheet_activity_id: state.currentSheetActivity.id,
      }

      await http.post(`/api/teacher/sheet_upload/reset_transform/${state.sheet_id}`, param).then(async response => {
        setSheetActivityImageSource(state.currentSheetActivity, response.data.image_url);
        const size = await loadImageSizeBySource(state.currentSheetActivity.imageSrc);
        setSheetActivityImageSize(state.currentSheetActivity, size.width, size.height);
        resetPreviewImageLoadState();
        state.currentSheetActivity.angle = 0;
        state.currentSheetActivity.sheetActivityHoseiPositions = response.data.sheet_activity_hosei_positions.map((x: any) => new SheetActivityHoseiPosition(x, state.currentSheetActivity.baseWidth, state.currentSheetActivity.baseHeight));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 手動補正実行 手動補正用コンポーネントから呼ばれる
     ************************************************************/

    const adjustImageShift = async (pageItems: any[]) => {

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/sheet_upload/adjust_image_shift/${state.sheet_id}`, {page_items: pageItems}).then(response => {
        alert("処理が完了しました。切出しを実行してください。");
        initialize();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 手動補正リセット 手動補正用コンポーネントから呼ばれる
     ************************************************************/

    const resetAdjustImageShift = async (examineeIds: number[]) => {

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/sheet_upload/reset_adjust_image_shift/${state.sheet_id}`, {examinee_ids: examineeIds}).then(response => {
        alert("処理が完了しました。切出しを実行してください。");
        initialize();
        state.recogResults = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 答案並び替え完了状態更新
     ******************************/

    const sortAnswerImageCompletedChanged = async (newValue: any) => {

      state.errors = []
      await http.post(`/api/teacher/sheet_upload/update_sort_answer_image_completed/${state.sheet_id}`, {is_sort_answer_image_completed: newValue.value}).then(response => {
        state.sheet.is_sort_answer_image_completed = newValue.value;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /******************************
     * 切出しボタン活性判定
     ******************************/

     const isImageCutDisabled = computed((): boolean => {
      return context.root.$store.getters.isNormalSheet 
        && context.root.$store.getters.isOptionSortAnswerImageRequiredActive 
        && state.sheet.is_sort_answer_image_enable 
        && !state.sheet.is_sort_answer_image_completed
        && !state.sheet.is_digital_paper;
    });

    /******************************
     * 初期表示データ取得
     ******************************/

    const initialize = async () => {
      
      let hoseiExaminee: Examinee = null;
      
      await http.get(`/api/teacher/sheet_upload?sheet_id=${state.sheet_id}&version=20260224`).then(async response => {        
        state.sheet = response.data.sheet;
        state.is_hosei_enable = response.data.is_hosei_enable;
        state.is_studnet_key_recog_enable = response.data.is_studnet_key_recog_enable;
        state.sheetFields = response.data.sheet_fields.map((x: any) => new SheetField(x));
        const examinees = new Array<Examinee>();
        response.data.sheet.examinees.forEach((x: any) => {
          examinees.push(new Examinee(x, response.data.sheet.sheet_activities, response.data.sheet_activity_hosei_positions, response.data.correct_hosei_positions, state.sheet.correct_image_size[0], state.sheet.correct_image_size[1]));
        });
        state.examinees = examinees;
        
        if(uploadedExaminees.value.length > 0){
          await changeCurrent(uploadedExaminees.value[0], 0);
        }

        state.is_exists_backup_image = state.examinees.filter(x => x.sheetActivities.filter(y => y.is_exists_backup_image).length > 0).length > 0;
        state.recogResults = [];
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      state.hoseiExaminee = hoseiExaminee;
    };

    /******************************
     * created
     ******************************/

    const created = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;

      await initialize();

      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keyup", keyUp);

      context.root.$nextTick(() => {
        adjustHeight();
      });

      const tableArea = document.getElementById("table-area");
      const headerLeftArea = document.getElementById("header-left-area");
      if(headerLeftArea){
        headerLeftArea.style.width = `${tableArea.clientWidth}px`;
      }

      context.root.$store.dispatch("hideOverlay");
    };

    // created処理呼び出し
    created();

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      if(state.previewImageRetryTimer != null){
        clearTimeout(state.previewImageRetryTimer);
        state.previewImageRetryTimer = null;
      }
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      SheetTypeEnum,
      modalSheetUploadRef,
      modalMeiboUploadRef,
      uploadedExaminees,
      unUploadedExaminees,
      currentSheetFields,
      imageStyle,
      imageWrapStyle,
      previewImageError,
      changeCurrent,
      scaleUp,
      scaleDown,
      adjustWidth,
      adjustHeight,
      rotateLeft,
      rotateRight,
      rotateSave,
      rotateAll,
      saveMeibo,
      closeSheetUploadModal,
      showAbsentModal,
      showMeiboModal,
      upload,
      destroyAll,
      destroy,
      uploadMeibo,
      downloadMeiboTemplate,
      imageCut,
      keyUp,
      toSortAnswerImage,
      dropAreaText,
      hoseiDragStop,
      tdStyle,
      circleCenter,
      perspectiveTransform,
      resetTransform,
      adjustImageShift,
      resetAdjustImageShift,
      sortAnswerImageCompletedChanged,
      recogStudentKey,
      sortByRecogResult,
      isImageCutDisabled,
     };
  }
})
